var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('ExpansionPanel',{attrs:{"headerText":"Datepicker"}},[_c('div',[_c('Datepicker')],1),_c('div',[_c('Datepicker',{attrs:{"has-range":false}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }